<template>

  <div>
    <b-container fluid class="foot_container">
      <b-col cols="12" offset-md="2" md="8" class="border_bot">
        <b-row>
          <b-col lg="4" cols="4">
            <ul class="list_container_no_title first_list">
              <li>本社所在地：</li>
              <li>〒101-0025</li>
              <li>東京都千代田区神田</li>
              <li>佐久間町３丁目５番</li>
              <li>第２櫻井ビル３Ｆ３０号室</li>
              <li>電話番号：03-5821-8561</li>
              <li>FAX番号：03-5821-8562</li>
            </ul>
          </b-col>
          <b-col lg="2" offset-lg="1" cols="6">
            <ul class="list_container">
              <li>事業内容</li>
              <li>IT人材派遣</li>
              <li>システム開発</li>
              <li>ITコンサルティング</li>
              <li>スマホApp開発</li>
              <li>ウェブサイト開発</li>
            </ul>
          </b-col>
          <b-col lg="2" cols="6">
            <ul class="list_container">
              <li>スマホApp実績</li>
              <li>RussellME</li>
              <li>IMOwner</li>
              <li>Health Amulet</li>
              <li>TOYOTA</li>
              <li>統一AI学生</li>
            </ul>
          </b-col>
          <b-col lg="2" cols="6">
            <ul class="list_container">
              <li>主要取引先</li>
              <li>LIXIL</li>
              <li>DXC</li>
              <li>ITステージ</li>
              <li>リアルシス</li>
              <li>FOUNDER</li>
            </ul>
          </b-col>

        </b-row>
      </b-col>
      <b-col cols="12" style="margin-top: 25px;font-size: 12px">Copyright © 2016-2020 OriginalInfoTec Co.,Ltd. All Rights Reserved.</b-col>
    </b-container>
  </div>
</template>

<script>
export default {
name: "foot"
}
</script>

<style scoped>
  .foot_container{

    height: auto;
    bottom: 0;
    background-color: #3d3d3d;
    margin-top: 0;
    color: #ffffff;
    z-index: 99999;

  }
  .list_container{
    list-style: none;
  }
  .list_container>li{
    margin-top: 10px;
    font-size: 13px;
    text-align: left;
  }

  .list_container_no_title{
    list-style: none;
  }
  .list_container_no_title>li{
    margin-top: 10px;
    font-size: 13px;
    text-align: left;
  }

  @media (min-width:992px) {
    .first_list{
      border-right: 1px solid #999999;
    }
  }

  .list_container>li:first-child{
    font-size: 14px;
    font-weight: bolder;

  }
  .foot_container_static{
    position: static!important;
  }
  .border_bot{
    border-bottom: 1px solid #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/foot/foot.vue